import styled from 'styled-components';
import { COLORS, BORDER_RADIUS, SPACING } from '../../constants/theme';

export const Card = styled.div`
	background: ${COLORS.white};
	border: 1px solid ${COLORS.light.medium};
	border-radius: ${BORDER_RADIUS.large};
	overflow: hidden;
`;

export const CardSection = styled.div`
	padding: ${SPACING.large} ${SPACING.extraLarge};
	display: flex;
	flex-direction: column;
	gap: ${SPACING.medium};
`;

export const SectionDivider = styled.div`
	height: 8px;
	background: ${COLORS.light.low};
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	gap: ${SPACING.medium};
`;

export const IconBadge = styled.div`
	width: 46px;
	height: 46px;
	border-radius: ${BORDER_RADIUS.medium};
	background: ${COLORS.primary.low};
	color: ${COLORS.primary.pure};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	font-size: 19px;
`;
